import { pageTypeConstants } from '../../constants/pageTypeConstants.ts';
import {
    areFiltersApplied,
    type AreFiltersAppliedItemSearch,
} from '../../finding/helpers/appliedFilters/areFiltersApplied.ts';

const MULTI_VERTICAL_FILTER = 'multiVertical';

export const isMultiVerticalPage = ({
    pageType,
    searchTerm,
    itemSearch,
}: {
    pageType: string | null | undefined;
    searchTerm: string | null | undefined;
    itemSearch: AreFiltersAppliedItemSearch;
}): boolean => {
    return (
        pageType === pageTypeConstants.SEARCH &&
        !searchTerm &&
        areFiltersApplied(itemSearch, [MULTI_VERTICAL_FILTER])
    );
};
